<div class="bina-catalog-item" [ngClass]="{ 'hover-background': isShowHoverBackground, 'no-min-height': !isWithMinHeight }">
  <div class="bina-catalog-item__left-col" [ngClass]="{ invalid: !favoriteHtsNumber?.isActive }">
    <div class="bina-catalog-item__code-wrapper">
      <ng-content *ngTemplateOutlet="codeGroupItem; context: { startingIndex: 0, length: 4, showDot: true }"></ng-content>
      <ng-content *ngTemplateOutlet="codeGroupItem; context: { startingIndex: BINA_SECOND_GROUP_NUM, showDot: true }"></ng-content>
      <ng-content *ngTemplateOutlet="codeGroupItem; context: { startingIndex: BINA_THIRD_GROUP_NUM, length: 4 }"></ng-content>
    </div>

    <!--HTS no longer valid tag-->
    <div *ngIf="!favoriteHtsNumber?.isActive" class="bina-catalog-item__invalid-tag">
      <span class="bina-catalog-item__invalid-tag__text">
        {{ "LABELS.HTS_NO_LONGER_VALID" | translate | uppercase }}
      </span>
    </div>
  </div>

  <div class="bina-catalog-item__middle-col">
    <div class="bina-catalog-item__content">
      <div class="bina-catalog-item__content__header">
        <div class="d-flex">
          <p class="bina-catalog-item__content__header-title">{{ favoriteHtsNumber.title }}</p>
          <img
            class="bina-catalog-item__content__header-icon"
            src="assets/icons/edit_gray.svg"
            *ngIf="isHasSupportForItemElement(enumBinaCatalogItemElementType.TITLE_EDIT_ICON)"
            (click)="openCatalogItemTitleEditSidebar(favoriteHtsNumber.id, favoriteHtsNumber.title)"
          />
        </div>
        <!--Insert hts-->
        <div
          class="bina-catalog-item__action"
          nz-tooltip
          nzTooltipPlacement="top"
          [nzTooltipTitle]="'INSERT_TO_LINE_ITEM' | translate"
          (click)="htsInsert.emit(favoriteHtsNumber)"
          *ngIf="isHasSupportForItemElement(enumBinaCatalogItemElementType.INSERT_TO_LINE_ITEM)"
        >
          <div class="bina-catalog-item__action-button">
            <img src="assets/icons/icon_insert_item.svg" />
          </div>
        </div>
      </div>
      <div class="bina-catalog-item__content__body">
        <div class="bina-catalog-item__content__body-description-wrapper">
          <p
            #binaCatalogItemDescription
            [ngClass]="{ 'm-0': !isHasSupportForItemElement(enumBinaCatalogItemElementType.BASED_ON_YOUR_SEARCH) }"
            class="bina-catalog-item__content__body-description"
          >
            {{ !isItemDescriptionTruncated || isShowingMore ? favoriteHtsNumber.description : truncatedHtsDescription }}
            <span
              type="button"
              class="btn btn-link bina-catalog-item__content__body-description__show-more"
              (click)="onShowMore()"
              *ngIf="isItemDescriptionTruncated"
            >
              {{ (isShowingMore ? "BUTTON.SHOW_LESS" : "BUTTON.SHOW_MORE") | translate }}
            </span>
          </p>
        </div>

        <p
          class="bina-catalog-item__content__body-search-query"
          *ngIf="isHasSupportForItemElement(enumBinaCatalogItemElementType.BASED_ON_YOUR_SEARCH)"
        >
          {{ "LABELS.BASED_ON_YOUR_SEARCH" | translate }}:
          <span class="bina-catalog-item__content__body-search-query__emphasis">{{ favoriteHtsNumber.searchQuery }}</span>
        </p>

        <!--Tariff Status Tag-->
        <div
          *ngIf="isTariffStatusChanged"
          class="bina-catalog-item__tariff-status mt-2"
          [ngClass]="{
            'tariff-changed': isTariffChanged,
            'tariff-increased': isTariffIncreased,
            'tariff-decreased': isTariffDecreased
          }"
        >
          <img
            *ngIf="isTariffIncreased || isTariffDecreased"
            class="bina-catalog-item__tariff-status__icon"
            [src]="tariffStatusIndicatorIconSrc"
          />
          <span class="bina-catalog-item__tariff-status__text">
            {{ "LABELS.UPDATED_TARIFF" | translate | uppercase }}
          </span>
        </div>
      </div>
      <div
        class="bina-catalog-item__content__footer"
        [ngClass]="{ open: isDutiesRatesToggled }"
        *ngIf="isHasSupportForItemElement(enumBinaCatalogItemElementType.MIDDLE_COLUMN_FOOTER)"
      >
        <div class="bina-catalog-item__duties-rates-collapsible">
          <div class="bina-catalog-item__duties-rates-collapsible__header" (click)="onDutiesToggle()">
            <p class="bina-catalog-item__duties-rates-collapsible__header-title">{{ "LABELS.DUTIES_RATES" | translate }}</p>
            <img
              class="bina-catalog-item__duties-rates-collapsible__header-icon"
              [ngClass]="{ open: isDutiesRatesToggled }"
              src="assets/icons/icon_chevron_right.svg"
            />
          </div>
          <div class="bina-catalog-item__duties-rates-collapsible__body" *ngIf="isDutiesRatesToggled">
            <div class="bina-catalog-item__duties-rates-collapsible__field">
              <p class="bina-catalog-item__duties-rates-collapsible__field-label">{{ "LABELS.UNIT_OF_QUANTITY" | translate }}:</p>
              <p class="bina-catalog-item__duties-rates-collapsible__field-value">{{ unitOfQuantity }}</p>
            </div>

            <div class="bina-catalog-item__duties-rates-collapsible__field">
              <p class="bina-catalog-item__duties-rates-collapsible__field-label">{{ "LABELS.GENERAL" | translate }}:</p>

              <!--General calculation/url-->
              <p
                *ngIf="!!favoriteHtsNumber?.dutyComputationFormula; else htsExternalSearch"
                class="bina-catalog-item__duties-rates-collapsible__field-value"
              >
                {{ favoriteHtsNumber?.dutyComputationFormula }}
              </p>
              <ng-template #htsExternalSearch>
                <a
                  class="bina-catalog-item__duties-rates-collapsible__field-value link"
                  [href]="htsExternalSearchUrl + favoriteHtsNumber.htsNumber"
                  target="_blank"
                >
                  {{ "LABELS.EXPLORE_TARIFF_RATES" | translate }}
                </a>
              </ng-template>
            </div>

            <div class="bina-catalog-item__duties-rates-collapsible__field" *ngIf="!!specialProgramIndicators">
              <p class="bina-catalog-item__duties-rates-collapsible__field-label">{{ "LABELS.SPECIAL" | translate }}:</p>
              <p class="bina-catalog-item__duties-rates-collapsible__field-value">{{ specialProgramIndicators }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bina-catalog-item__right-col" *ngIf="isHasSupportForItemElement(enumBinaCatalogItemElementType.RIGHT_COLUMN)">
    <div class="bina-catalog-item__actions">
      <button
        *ngIf="!!favoriteHtsNumber?.isActive; else reclassifyButton"
        type="button"
        class="btn btn-link bina-catalog-item__actions__calculate"
        (click)="onCalculatorClick()"
      >
        <img class="bina-catalog-item__actions__calculate-icon" src="/assets/icons/icon_calculator_white.svg" />
      </button>

      <ng-template #reclassifyButton>
        <button type="button" class="btn btn-link bina-catalog-item__actions__reclassify" (click)="onReclassifyClick()">
          <img class="bina-catalog-item__actions__reclassify-icon" src="/assets/icons/icon_reclassify_green.svg" />
        </button>
      </ng-template>

      <ng-container *ngTemplateOutlet="binaItemOptionsDropdown"></ng-container>
    </div>
  </div>
</div>

<!--Templates-->
<ng-template #codeGroupItem let-startingIndex="startingIndex" let-length="length" let-showDot="showDot">
  <app-bina-code-item [groupNumber]="getCodeGroupAt(startingIndex, length)" [showDot]="showDot"></app-bina-code-item>
</ng-template>

<ng-template #binaItemOptionsDropdown>
  <div class="bina-catalog-item-options-menu" dropdown container="body" placement="bottom right">
    <button
      id="bina-catalog-item-options-menu-{{ favoriteHtsNumber.id }}"
      dropdownToggle
      type="button"
      class="btn btn-link dropdown-toggle bina-catalog-item-options-menu__button"
    >
      <i class="fa fa-ellipsis-h"></i>
    </button>
    <ul
      id="bina-catalog-item-options-menu-dropdown-{{ favoriteHtsNumber.id }}"
      class="dropdown-menu dropdown-menu-right bina-catalog-item-options-menu__list"
      role="menu"
      *dropdownMenu
    >
      <li
        role="menuitem"
        class="cursor-pointer dropdown-item bina-catalog-item-options-menu__item"
        (click)="onDeleteItem(favoriteHtsNumber.id)"
      >
        <div>
          <img class="bina-catalog-item-options-menu__item-img" src="assets/icons/trash_gray.svg" />
          <span>{{ "BUTTON.DELETE_FROM_CATALOG" | translate }}</span>
        </div>
      </li>
      <li
        role="menuitem"
        class="cursor-pointer dropdown-item bina-catalog-item-options-menu__item"
        (click)="openCatalogItemTitleEditSidebar(favoriteHtsNumber.id, favoriteHtsNumber.title)"
      >
        <div>
          <img class="bina-catalog-item-options-menu__item-img" src="assets/icons/edit_gray.svg" />
          <span>{{ "BUTTON.CHANGE_TITLE" | translate }}</span>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
